import React from 'react'
import './CybersecurityContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaLock, FaShieldAlt, FaClipboardList } from 'react-icons/fa'

export class CybersecurityContent extends React.Component {
  render() {
    return (
      <div className="cybersecurity-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner maintains Top Secret Facilities Clearance with 50%+ of its
            workforce TS-eligible or higher, and our cybersecurity professionals
            hold certifications including CISSP, Security+, and CySA+ in
            compliance with DoD 8570/8140 workforce standards.
          </div>
        </div>

        <section className="padding-large">
          <h2>Zero Trust Architecture</h2>
          <div className="row">
            <div className="col-md-12">
              <p className="centered">
                Rackner led the first IL-6 deployment at a DoD software factory,
                implementing a cloud-based enterprise security framework with a
                Zero Trust Architecture core.
              </p>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Integrated Security Approach</h2>
          <div className="row security-pillars">
            <div className="col-md-4">
              <div className="pillar-card">
                <div className="icon"><FaLock /></div>
                <div className="title">CI/CD Pipeline Security</div>
                <div className="description">
                  Automated code scanning, STIG-based configuration checks, and
                  automated evidence capture formatted for eMASS upload to
                  streamline RMF package development and audits
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="pillar-card">
                <div className="icon"><FaShieldAlt /></div>
                <div className="title">Access Control</div>
                <div className="description">
                  Role-based access control, multi-factor authentication,
                  comprehensive audit logging, and continuous monitoring across
                  all systems
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="pillar-card">
                <div className="icon"><FaClipboardList /></div>
                <div className="title">Compliance Management</div>
                <div className="description">
                  Full alignment with DoD Cybersecurity Risk Management Construct
                  (CSRMC) across design, build, test, onboard, and operate phases
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>24/7/365 Security Operations</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="ops-feature">
                <h3>Continuous Monitoring</h3>
                <ul>
                  <li>Daily security log analysis using Splunk</li>
                  <li>Systematic ACAS vulnerability report review</li>
                  <li>Rigorous user profile management with least-privilege access</li>
                  <li>Quarterly access audits and privilege reviews</li>
                </ul>
              </div>
            </div>
            <div className="col-md-6">
              <div className="ops-feature">
                <h3>Proven Reliability</h3>
                <ul>
                  <li>99.9% system availability on homeland security systems supporting 120,000+ users</li>
                  <li>Emergency response 2.5x faster than previous teams</li>
                  <li>Maintained full availability during emergency response operations</li>
                  <li>Automated incident detection and response workflows</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Defense-in-Depth Principles</h2>
          <div className="defense-layers">
            <div className="layer">
              <div className="layer-title">Network Security</div>
              <div className="layer-description">
                Segmentation, firewalls, intrusion detection/prevention, and
                encrypted communications
              </div>
            </div>
            <div className="layer">
              <div className="layer-title">Application Security</div>
              <div className="layer-description">
                Secure coding practices, automated vulnerability scanning, and
                penetration testing
              </div>
            </div>
            <div className="layer">
              <div className="layer-title">Data Security</div>
              <div className="layer-description">
                Encryption at rest and in transit, data loss prevention, and secure
                backup strategies
              </div>
            </div>
            <div className="layer">
              <div className="layer-title">Identity & Access Management</div>
              <div className="layer-description">
                CAC/PIV authentication, RBAC, privilege management, and session
                monitoring
              </div>
            </div>
            <div className="layer">
              <div className="layer-title">Security Operations</div>
              <div className="layer-description">
                24/7 monitoring, incident response, threat intelligence, and
                continuous improvement
              </div>
            </div>
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Discuss Your Security Needs
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default CybersecurityContent
